import { useEffect, useState } from 'react';
import { Alert, Snackbar as MuiSnackbar } from '@mui/material';

let listeners = [];

export const showSnackbar = (message, options = {}) => {
  const snackbar = {
    id: Date.now() + Math.random(),
    message,
    severity: options.severity || 'success',
    duration: options.duration || 4000,
  };

  listeners.forEach((listener) => listener(snackbar));
  return snackbar.id;
};

const Snackbar = () => {
  const [snackbar, setSnackbar] = useState(null);

  useEffect(() => {
    const handleSnackbar = (nextSnackbar) => {
      setSnackbar(nextSnackbar);
    };

    listeners.push(handleSnackbar);

    return () => {
      listeners = listeners.filter((listener) => listener !== handleSnackbar);
    };
  }, []);

  const handleClose = () => {
    setSnackbar(null);
  };

  return (
    <MuiSnackbar
      open={Boolean(snackbar)}
      autoHideDuration={snackbar?.duration || 4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={handleClose} severity={snackbar?.severity || 'success'} sx={{ width: '100%' }}>
        {snackbar?.message}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
